import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import Editor from './Editor';

// Updated object structure for reference (includes 2 background images and 4 decorative images)
const importedData = {
  "task_type_id": "comic_story_a2",
  "background_image": "",
  "background_image_2": "",
  "decorative_image": "",
  "decorative_image_2": "",
  "decorative_image_3": "",
  "decorative_image_4": "",
  "items": [
    {
      "phase": "PHASE_1",
      "group": "GROUP_1",
      "is_example": true,
      "is_capital": false,
      "rubric_id": "",
      "stimulus_text": "",
      "question_1": "",
      "question_2": "",
      "answers": [
        {
          "is_correct_answer": true,
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_1",
      "group": "GROUP_1",
      "is_example": false,
      "is_capital": false,
      "rubric_id": "",
      "stimulus_text": "",
      "question_1": "",
      "question_2": "",
      "answers": [
        {
          "is_correct_answer": true,
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_1",
      "group": "GROUP_2",
      "is_example": false,
      "is_capital": false,
      "rubric_id": "",
      "stimulus_text": "",
      "question_1": "",
      "question_2": "",
      "answers": [
        {
          "is_correct_answer": true,
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_1",
      "group": "GROUP_2",
      "is_example": false,
      "is_capital": false,
      "rubric_id": "",
      "stimulus_text": "",
      "question_1": "",
      "question_2": "",
      "answers": [
        {
          "is_correct_answer": true,
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_1",
      "group": "GROUP_3",
      "is_example": false,
      "is_capital": false,
      "rubric_id": "",
      "stimulus_text": "",
      "question_1": "",
      "question_2": "",
      "answers": [
        {
          "is_correct_answer": true,
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_1",
      "group": "GROUP_3",
      "is_example": false,
      "is_capital": false,
      "rubric_id": "",
      "stimulus_text": "",
      "question_1": "",
      "question_2": "",
      "answers": [
        {
          "is_correct_answer": true,
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_2",
      "group": null,
      "is_example": false,
      "is_capital": false,
      "stimulus_text": "",
      "rubric_id": "",
      "answers": [
        {
          "is_correct_answer": false,
          "text": "",
          "key": []
        },
        {
          "is_correct_answer": true,
          "text": "",
          "key": []
        },
        {
          "is_correct_answer": false,
          "text": "",
          "key": []
        }
      ]
    },
    {
      "phase": "PHASE_3",
      "group": null,
      "is_example": false,
      "is_capital": false,
      "answers": [
        {
          "is_correct_answer": true,
          "image_id": "",
          "key": [],
          "training_sentences": []
        },
        {
          "is_correct_answer": true,
          "image_id": "",
          "key": [],
          "training_sentences": []
        },
        {
          "is_correct_answer": true,
          "image_id": "",
          "key": [],
          "training_sentences": []
        }
      ]
    }
  ]
};

export default createTaskType({
  id: 'comic_story_a2',
  label: 'Comic Story',
  skill: 'reading_writing',
  v2: true,
  hasRubric: true,

  editor: Editor,
  createItemsTemplate: () => [
    ...times(6, (i) => createPhase1Item(i)),
    createPhase2Item(6),
    createPhase3Item(7)
  ],

  convertToLocalFormat(task) {
    task.items = task.items.map(item => {
      const groupParts = item.group?.split('GROUP_') ?? [];
      item.group = groupParts.length === 2 ? parseInt(groupParts[1]) : null;

      item.question_left = item.question_1 || '';
      item.question_right = item.question_2 || '';

      if (item.phase === 'PHASE_3' && Array.isArray(item.answers)) {
        item.answers = item.answers.map(ans => ({
          ...ans,
          image: ans.image_id || '', // map back to image field used by editor
        }));
      }
      return item;
    });

    if (task.decorative_image && task.items[1]) {
      task.items[1].decorative_image = task.decorative_image;
    }
    if (task.decorative_image_2 && task.items[2]) {
      task.items[2].decorative_image = task.decorative_image_2;
    }
    if (task.decorative_image_3 && task.items[4]) {
      task.items[4].decorative_image = task.decorative_image_3;
    }
    if (task.decorative_image_4 && task.items[6]) {
      task.items[6].decorative_image = task.decorative_image_4;
    }

    task.decorative_image = task.items[1]?.decorative_image || task.decorative_image || '';
    task.decorative_image_2 = task.items[2]?.decorative_image || task.decorative_image_2 || '';
    task.decorative_image_3 = task.items[4]?.decorative_image || task.decorative_image_3 || '';
    task.decorative_image_4 = task.items[6]?.decorative_image || task.decorative_image_4 || '';
    return task;
  },

  convertToUploadFormat(task, { isNew }) {
    task = cloneDeep(task);


    task.background_image = task.background_image || '';
    task.background_image_2 = task.background_image_2 || '';

    // Add top-level decorative images for upload
    task.decorative_image = task.items[1]?.decorative_image || task.decorative_image || '';
    task.decorative_image_2 = task.items[2]?.decorative_image || task.decorative_image_2 || '';
    task.decorative_image_3 = task.items[4]?.decorative_image || task.decorative_image_3 || '';
    task.decorative_image_4 = task.items[6]?.decorative_image || task.decorative_image_4 || '';




    task.items = task.items.map(item => {
      // Map question_left/right to question_1/question_2
      const question_1 = item.question_left || null;
      const question_2 = item.question_right || null;

      const { question_left, question_right, decorative_image, ...rest } = item;

      const answers = (item.answers || []).map(answer => {
        if (item.phase === 'PHASE_3') {
          if (typeof answer.image === 'string') {
            answer.image_id = answer.image || null;
          }
          delete answer.image;
        }
        if (typeof answer.key === 'string') {
          answer.key = answer.key.split(',').map(x => x.trim()).filter(x => !!x);
        }
        if (typeof answer.training_sentences === 'string') {
          answer.training_sentences = answer.training_sentences.split(',').map(x => x.trim()).filter(x => !!x);
        }
        return answer;
      });

      return {
        ...rest,
        stimulus_text: item.stimulus_text?.length >= 1 ? item.stimulus_text : null,
        question_1,
        question_2,
        group: !!item.group ? `GROUP_${item.group}` : null,
        answers
      };
    });
    delete task.context_audio_id;

    return task;
  },

  getKeys: (item) => {
    return (item.answers || []).filter(x => x.is_correct_answer).map(x => {
      if (Array.isArray(x.key) && x.key.length) return x.key.join(', ');
      if (typeof x.text === 'string' && x.text.trim().length) return x.text;
      return Array.isArray(x.key) ? x.key.join(', ') : '';
    });
  }
});

// Updated item creation functions (includes all required fields)
function createPhase1Item(index, overrides = {}) {
  let group = null;
  if (index === 0 || index === 1) group = 1;
  else if (index === 2 || index === 3) group = 2;
  else if (index === 4 || index === 5) group = 3;
  return {
    phase: 'PHASE_1',
    is_example: index === 0,
    is_capital: false,
    ...(index === 0 && { rubric_id: '' }),
    group,
    stimulus_text: '',
    question_1: '',
    question_2: '',
    answers: [{
      is_correct_answer: true,
      key: [],
    }],
    ...overrides
  };
}

function createPhase2Item(index) {
  return {
    phase: 'PHASE_2',
    is_example: false,
    is_capital: false,
    stimulus_text: '',
    rubric_id: '',
    answers: times(3, () => ({
      is_correct_answer: false,
      text: '',
      key: [],
    })),
  };
}
function createPhase3Item(index) {
  return {
    phase: 'PHASE_3',
    is_example: false,
    is_capital: false,
    ...(index === 7 && { rubric_id: '' }),
    answers: times(3, () => ({
      is_correct_answer: true,
      image_id: '',
      key: [],
      training_sentences: []
    })),
  };
}
